export const branding = {
  mainColor: '#1C9996',
  secondaryColor: '#1F3444'
};
